module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/cover-atami-1-197c31889e3151052e24fdad0a509f48.webp";